import { render } from "./productadmin.vue?vue&type=template&id=69db1f01"
import script from "./productadmin.vue?vue&type=script&lang=js"
export * from "./productadmin.vue?vue&type=script&lang=js"

import "./productadmin.vue?vue&type=style&index=0&id=69db1f01&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__